import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal } from './Modal'
import { Button } from './Button'

interface SignUpPromptModalProps {
    isOpen: boolean
    onClose: () => void
    featureName: string
}

export const SignUpPromptModal: React.FC<SignUpPromptModalProps> = ({
    isOpen,
    onClose,
    featureName,
}) => {
    const navigate = useNavigate()

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={`Unlock ${featureName}`}>
            <div className="space-y-6">
                <div className="text-center">
                    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 mb-4">
                        <svg
                            className="h-6 w-6 text-primary-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
                            />
                        </svg>
                    </div>
                    <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white">
                        Sign up to access {featureName}
                    </h3>
                    <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                        Create a free account to access {featureName.toLowerCase()}, track your progress, and save your learning history.
                    </p>
                </div>

                <div className="flex flex-col space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3">
                    <Button
                        variant="primary"
                        className="w-full justify-center"
                        onClick={() => navigate('/auth')}
                    >
                        Sign Up Free
                    </Button>
                    <Button
                        variant="outline"
                        className="w-full justify-center"
                        onClick={onClose}
                    >
                        Maybe Later
                    </Button>
                </div>
            </div>
        </Modal>
    )
}
